import { Button, Input, Spacer, VDBText } from "@components/atoms";
import { ButtonType } from "@components/atoms/Button/types";
import useScreenOptionsHooks from "../../../hooks/useScreenOptionsHooks";
import { useTranslation } from "react-i18next";
import { getButtonCategory } from "@utils/product/productValidators";
import Popup from "@components/molecules/PopUp";
import { messageType } from "@components/molecules/PopUp/types";
import { SpaceType } from "@components/atoms/Spacer/types";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { ownerInfoSchema } from "./ownerInfoSchema";
import { useState } from "react";
import { User } from "@src/types/user";
import OwnerInfoModal from "./OwnerInfoModal";
import { diamonds } from "@src/types/DiamondDetail";
import styled from "styled-components/native";

const OwnerInfo = ({
  productType,
  userInfo,
  itemDetail,
}: {
  productType: string;
  userInfo: User;
  itemDetail: diamonds;
}) => {
  const { theme, typography } = useScreenOptionsHooks();
  const { t } = useTranslation();
  const { control, setError, reset, handleSubmit } = useForm({
    resolver: yupResolver(ownerInfoSchema(t)),
  });
  const [showPopUp, setShowPopUp] = useState(false);
  const [showOwnerInfo, setShowOwnerInfo] = useState(false);

  const handleButtonAction = () => {
    if (userInfo.owner_info_authentication_pin) {
      setShowPopUp(true);
    } else {
      setShowOwnerInfo(true);
    }
  };

  const verifyAuthenticationPin = (pin: string) => {
    if (userInfo.owner_info_authentication_pin === pin) {
      setShowOwnerInfo(true);
      reset();
      setShowPopUp(false);
    } else {
      setError("password", {
        type: "validate",
        message: "Entered Password is Wrong",
      });
    }
  };
  return (
    <>
      <ButtonContainer
        style={{ maxWidth: theme.isLargeScreen ? 132 : undefined }}
      >
        <Button
          category={getButtonCategory(productType)}
          type={ButtonType.tertiary}
          title={
            t("productDetail.ownerInfo.button.text") ||
            userInfo?.owner_info?.label
          }
          onPress={() => {
            handleButtonAction();
          }}
        />
      </ButtonContainer>
      <OwnerInfoModal
        isOpen={showOwnerInfo}
        onClose={() => setShowOwnerInfo(false)}
        itemDetail={itemDetail}
        productType={productType}
      />
      {showPopUp && (
        <Popup
          type={messageType.Generic}
          styleKey="Body-R"
          title={t("productDetail.ownerInfo.popUp.title.text")}
          buttons={[
            {
              type: ButtonType.primary,
              title: t(
                "productDetail.ownerInfo.popUp.button.primary.title.text"
              ),
              category: getButtonCategory(productType),
              onPressAction: handleSubmit((data) =>
                verifyAuthenticationPin(data.password)
              ),
            },
            {
              type: ButtonType.secondary,
              title: t(
                "productDetail.ownerInfo.popUp.button.secondary.title.text"
              ),
              category: getButtonCategory(productType),
              onPressAction: () => {
                reset();
                setShowPopUp(false);
              },
            },
          ]}
          hasChildren={true}
        >
          <VDBText type={typography["Body-M"]} color={theme["core-05"]}>
            {t("productDetail.ownerInfo.popUp.message.text")}
          </VDBText>

          <Spacer size={SpaceType.Basic} />

          <Controller
            control={control}
            render={({
              field: { onBlur, value, onChange },
              formState: { errors },
            }) => (
              <Input
                inputLabel={t("Password")}
                placeholder={t("Password")}
                onBlur={onBlur}
                onChangeText={onChange}
                value={value}
                secureTextEntry={true}
                error={errors?.password?.message}
              />
            )}
            name="password"
          />
        </Popup>
      )}
    </>
  );
};

const ButtonContainer = styled.View`
  flex: 1;
  padding-top: ${({ theme }) => (theme.isLargeScreen ? "0dp" : "16px")};
  padding-bottom: ${({ theme }) => (theme.isLargeScreen ? "0dp" : "16px")};
`;

export default OwnerInfo;
